import { useRouter } from "next/router";
import { useUser } from "../../../hooks/useUser";
import { IconContainer } from "../../Buttons/IconContainer";
import { UnderlinedButton } from "../../Buttons/UnderlinedButton";
import { Container } from "../../Container/Container"
import EditIcon from "../../../public/images/icons/edit.svg";
import VerifiedUser from "../../../public/images/icons/verified_user.svg";
import Link from "next/link";
import useTranslation from "next-translate/useTranslation";


export const ProfileActions = () => {
    const router = useRouter();
    const { isLoading, data, isMe } = useUser(router.query.username as string);
    const { t } = useTranslation('users');

    return (
        <div className="my-1 flex flex-row gap-x-1">
            <Container className="flex-1 py-[15px] px-0" topL={false} topR={false} bottomR={false}>
                {isMe &&
                    <UnderlinedButton renderContainer={(props) => <Link {...props} />} href={`/user/profile`}
                     underlineType="secondary" className="mx-auto lg:mx-4">
                        <IconContainer responsiveText={false} label={t('editProfile')} icon={<EditIcon className="w-8 h-8 text-white" />} />
                    </UnderlinedButton>
                }
                
            </Container>
            <Container className="flex-1 py-[15px] px-0" topL={false} topR={false} bottomL={false}>
                {isMe &&
                    <UnderlinedButton renderContainer={(props) => <Link {...props} />} href="/user/verify" underlineType="primary" className="mx-auto lg:mx-4">
                        <IconContainer responsiveText={false} label={t('getVerified')} icon={<VerifiedUser className="w-8 h-8 text-white" />} />
                    </UnderlinedButton>
                }
            </Container>
        </div>

    )
}